export default __webpack_public_path__ + "static/media/food2.8855aa01.png";